type Props = {
  height?: string;
  width?: string;
  fill?: string;
};

export default function PlusIcon({ height = '24', width = '24', fill = '#000000' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10.4" width="3.2" height="24" fill={fill} />
      <rect x="24" y="10.4" width="3.2" height="24" transform="rotate(90 24 10.4)" fill={fill} />
    </svg>
  );
}
